import { render, staticRenderFns } from "./AdminPaginationPerPage.vue?vue&type=template&id=c459b63a&"
import script from "./AdminPaginationPerPage.vue?vue&type=script&lang=ts&"
export * from "./AdminPaginationPerPage.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPaginationPerPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
